import { api, PublicProject } from '../api';
import { escapeHtml, timeAgo } from '../lib/utils';

export async function renderPublicProjects(app: HTMLElement): Promise<void> {
  app.innerHTML = `<div class="container"><div class="spinner">Loading public projects…</div></div>`;

  let projects: PublicProject[];
  try {
    const res = await api.get<{ projects: PublicProject[] }>('/projects/public');
    projects = res.projects;
  } catch (e: any) {
    app.innerHTML = `
      <div class="container">
        <div class="error-state">
          <h3>Could not load public projects</h3>
          <p class="muted">${escapeHtml(e.message)}</p>
          <button class="btn btn-primary" id="retry">Try again</button>
        </div>
      </div>
    `;
    app.querySelector('#retry')!.addEventListener('click', () => renderPublicProjects(app));
    return;
  }

  app.innerHTML = `
    <div class="container">
      <div class="page-head">
        <div>
          <h1>Public projects</h1>
          <p class="muted" style="margin:0;">Browse projects that anyone can explore in read-only mode.</p>
        </div>
      </div>
      <div class="list-toolbar">
        <input class="input" id="public-search" type="search" placeholder="Search by name or description…" aria-label="Search public projects" />
        <span class="muted" id="public-count"></span>
      </div>
      <div id="public-list"></div>
    </div>
  `;

  const input = app.querySelector<HTMLInputElement>('#public-search')!;
  const list = app.querySelector<HTMLElement>('#public-list')!;
  const countEl = app.querySelector<HTMLElement>('#public-count')!;

  const renderList = () => {
    const query = input.value.trim().toLowerCase();
    const filtered = query
      ? projects.filter(
          (p) =>
            p.name.toLowerCase().includes(query) ||
            (p.description || '').toLowerCase().includes(query)
        )
      : projects;

    countEl.textContent = `${filtered.length} project${filtered.length === 1 ? '' : 's'}`;

    if (filtered.length === 0) {
      list.innerHTML = `
        <div class="empty-state">
          <h3>${projects.length === 0 ? 'No public projects yet' : 'No matching projects'}</h3>
          <p class="muted">${
            projects.length === 0
              ? 'Check back later — public projects shared by other users will appear here.'
              : 'Try a different search term.'
          }</p>
        </div>
      `;
      return;
    }

    list.innerHTML = `
      <div class="project-grid">
        ${filtered
          .map(
            (p) => `
          <a class="project-card" href="#/public/${p.id}/overview">
            <h3>${escapeHtml(p.name)}</h3>
            <p>${escapeHtml(p.description) || '<span class="muted">No description</span>'}</p>
            <div class="project-meta">
              <span>Public</span>
              <span style="margin-left:auto;">${timeAgo(p.updatedAt)}</span>
            </div>
          </a>
        `
          )
          .join('')}
      </div>
    `;
  };

  input.addEventListener('input', renderList);
  renderList();
}
